import * as React from 'react';
import { MenuEntry, UploaderProvider } from '@europrocurement/flexy-components';

import { RouteObject } from 'react-router';
import {
    REALM_ADMIN,
    ROLE_API_SIGN_ADMIN,
    ROLE_API_SIGN_READ,
    ROLE_API_SIGN_WRITE,
} from '@europrocurement/l2d-keycloak';
import {
    signatureBasePath,
    signatureFichePath,
    signatureListeFullPath,
    signatureListePath,
    signatureNewFullPath,
    signatureListeDemandeurFullPath,
    signatureNewPath,
    signatureListeDemandeurPath,
    signatureDuplicatePath,
} from './constants/paths';

import SignatureRoot from './views/SignatureRoot';

import DossierSignatureListe from './views/DossierSignatureListe/DossierSignatureListe';

import DossierSignatureFiche from './views/DossierSignatureFiche/DossierSignatureFiche';

import DossierSignatureAdd from './views/DossierSignatureAdd/DossierSignatureAdd';

import DossierSignatureListeDemandeur from './views/DemandeurSignatureListe/DemandeurSignatureListe';
import DossierSignatureDucplicate from './views/DossierSignatureAdd/DossierSignatureDucplicate';

export const SignatureRouter: RouteObject = {
    path: signatureBasePath,
    element: <SignatureRoot />,
    children: [
        {
            path: signatureListePath,
            children: [
                {
                    path: '',
                    index: true,
                    element: <DossierSignatureListe />,
                },
                {
                    path: signatureFichePath,
                    element: <DossierSignatureFiche />,
                },
            ],
        },
        {
            path: signatureNewPath,
            element: (
                <UploaderProvider>
                    <DossierSignatureAdd />
                </UploaderProvider>
            ),
        },
        {
            path: signatureDuplicatePath,
            element: (
                <UploaderProvider>
                    <DossierSignatureDucplicate />
                </UploaderProvider>
            ),
        },
        {
            path: signatureListeDemandeurPath,
            element: <DossierSignatureListeDemandeur />,
        },
    ],
};

export const SignatureMenuEntries: MenuEntry[] = [
    {
        title: 'Signature électronique',
        icon: 'signature',
        role: [REALM_ADMIN],
        // 'api-sign:dossier-read'
        children: [
            {
                title: 'Liste des dossiers',
                icon: 'list',
                href: signatureListeFullPath,
                role: [REALM_ADMIN, ROLE_API_SIGN_READ],
            },
            {
                title: 'Nouveau dossier',
                icon: 'folder-plus',
                href: signatureNewFullPath,
                role: [REALM_ADMIN, ROLE_API_SIGN_WRITE],
            },
            {
                title: 'Référentiels',
                icon: 'gears',
                href: signatureListeDemandeurFullPath,
                role: [REALM_ADMIN, ROLE_API_SIGN_ADMIN],
            },
        ],
    },
];

export type ModuleSpec = {
    route: RouteObject;
    menu: MenuEntry[];
};

export const SignatureModuleSpec: ModuleSpec = {
    route: SignatureRouter,
    menu: SignatureMenuEntries,
};
